import { createRoot } from "react-dom/client";
import { WidgetComponentType } from "../types/WidgetModule";

type DefineComponent = {
  tag: string;
  Component: WidgetComponentType;
};

export function defineCustomElement({ tag, Component }: DefineComponent) {
  class CustomElement extends HTMLElement {
    connectedCallback() {
      const props = this.getProps();
      const variables = this.getVariables();
      const version = this.getVersion();
      const root = createRoot(this);
      root.render(
        <Component
          props={props}
          tag={tag}
          variables={variables}
          version={version}
        />
      );
    }

    getProps() {
      const propsScript = this.querySelector("script[data-props]");
      return propsScript ? JSON.parse(propsScript.innerHTML) : {};
    }

    getVariables() {
      const variablesScript = this.querySelector("script[data-variables]");
      return variablesScript ? JSON.parse(variablesScript.innerHTML) : {};
    }

    getVersion() {
      return this.getAttribute("version") ?? undefined;
    }
  }
  
  if (!customElements.get(tag)) {
    customElements.define(tag, CustomElement);
  }
}
